import { render, staticRenderFns } from "./VMMultiSelectGroup.vue?vue&type=template&id=2fc57d22&lang=pug&"
import script from "./VMMultiSelectGroup.vue?vue&type=script&lang=js&"
export * from "./VMMultiSelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports